"use strict";
/**
 * AppTemplate type definitions (Plan 45 §1).
 *
 * Top-level shape used by templates loaded via `loadTemplate(json | url)`.
 * Three stream-reference modes (§2.9): canonical (sections.itemKeys), provision-new
 * (customFields), and existing-stream-ref (existingStreamRefs).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_PRIVATE_PURPOSE = exports.DATASET_TEMPLATE_FORMAT = void 0;
/** `format` value identifying a published data-set template. */
exports.DATASET_TEMPLATE_FORMAT = 'hds-dataset-template';
/** `purpose` value for an app's own (non data-model) streams referenced by a data-set template. Read-only. */
exports.APP_PRIVATE_PURPOSE = 'app-private';
